import AmountSummary from '@/modules/finance/domain/amountSummary'

export default class FinanceState {
  vatSummaryItems: Array<AmountSummary> = []
  taxBaseSummaryItems: Array<AmountSummary> = []
}
